import { BodyText } from '@paypalcorp/pp-react'
import { merge } from 'lodash-es'
import PageMessage from 'ppbl/components/PageMessage'
import clientLogger from 'ppbl/utils/client-logger'
import { redirectToServerRoute } from 'ppbl/utils/common-utils'
import { trackClick, trackPage } from 'ppbl/utils/fpti-helper'
import { FPTI_EVENTS } from 'ppbl/utils/fptiEventNames'
import { getLocalizedText } from 'ppbl/utils/locale-helper'
import React, { useEffect } from 'react'

const fptiData = {
  page: 'unsupportedAccountPage',
  event_name: FPTI_EVENTS.PAGE.UNSUPPORTED_ACCOUNT,
}

type Props = {
  applicationType: string
}

const UnsupportedAccountPage: React.FC<Props> = ({ applicationType }) => {
  useEffect(() => {
    clientLogger.info(
      `Unsupported Page is Loaded : User account type is not supported - Application type is ${applicationType}`,
    )
    trackPage(fptiData)
  }, [])

  const onclick = () => {
    trackClick(
      merge(fptiData, {
        component: 'restartApplication_button',
        link: 'restartApplication_button',
      }),
    )
    redirectToServerRoute(`/merchant-lending/loanbuilder/logout`)
  }

  return (
    <PageMessage
      id="unSupportedPageMessage"
      type="error"
      onPrimaryAction={onclick}
      localization={{
        title: getLocalizedText('unsupportedAccount-page.title'),
        primaryText: getLocalizedText('unsupportedAccount-page.restartButton'),
      }}
    >
      <BodyText className="body__text">
        {getLocalizedText('unsupportedAccount-page.bodyText')}
      </BodyText>
    </PageMessage>
  )
}

export default UnsupportedAccountPage
